import { Label } from '@dc-shared-web/components/shadcn/label'
import {
  RadioGroupItem as ShadcnRadioGroupItem,
  RadioGroup,
} from '@dc-shared-web/components/shadcn/radio-group'
import { FC, ReactNode } from 'react'

export type RadioGroupItemProps = React.ComponentPropsWithoutRef<
  typeof ShadcnRadioGroupItem
> & {
  description?: ReactNode
  label: ReactNode
}

export const RadioGroupItem: FC<RadioGroupItemProps> = ({
  description,
  id,
  label,
  disabled,
  ...rest
}) => {
  return (
    <div className='tw-flex tw-gap-2'>
      <ShadcnRadioGroupItem
        id={id}
        className='tw-mt-0.5'
        disabled={disabled}
        {...rest}
      />
      <div>
        <Label htmlFor={disabled ? undefined : id} className='tw-text-sm'>
          {label}
          {description && (
            <p className='tw-text-sm tw-font-normal tw-text-neutral-500'>
              {description}
            </p>
          )}
        </Label>
      </div>
    </div>
  )
}

export { RadioGroup }
